module.exports = __webpack_public_path__ + "img/warehous-nothing.b804e9d9.png";